import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { Icon } from 'components/shared/Icon/Icon'

import { useContext } from 'hooks'
import { AlertPropsContext } from '../../context'
import { ICONS, SIZES } from '../../model'
import { ICON_SIZES } from './model'

import styles from './Message.module.scss'

export const Message = () => {
  const { message, size, variant } = useContext(AlertPropsContext)!

  return (
    <Box align="center" className={styles.message}>
      <Icon
        className={styles.icon}
        icon={variant && ICONS[variant]}
        size={size && ICON_SIZES[size]}
      />
      <p
        className={cx(styles.text, styles.size, {
          [styles.medium]: size === SIZES.MEDIUM,
          [styles.small]: size === SIZES.SMALL,
        })}
      >
        {message}
      </p>
    </Box>
  )
}
